"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _headlineLockup = _interopRequireDefault(require("@site/pattern-library-core/headline-lockup"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _base = require("@site/pattern-library-utils/base.functions");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _offerBanner = _interopRequireWildcard(require("./offer-banner"));
var _actions = _interopRequireDefault(require("../../elements/other/actions"));
var _playButton = _interopRequireDefault(require("../../elements/buttons/play-button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ScrollableContentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ScrollableContentContainer",
  class: "pl-swzp6qg"
});
const ContentBlock = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentBlock",
  class: "pl-c1f2wrlr",
  vars: {
    "c1f2wrlr-0": [({
      navHeights
    }) => `calc(100svh - (${navHeights?.mobile || 0}px + var(--primary-nav-height)))`],
    "c1f2wrlr-4": [({
      navHeights
    }) => `calc(100vh - (${navHeights?.desktop || 0}px + var(--primary-nav-height)))`],
    "c1f2wrlr-6": [({
      navHeights
    }) => `calc(100svh - (${navHeights?.desktop || 0}px + var(--primary-nav-height)))`]
  }
});
const BannerWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BannerWrapper",
  class: "pl-bdpukg6"
});
const MobilePlayButton = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobilePlayButton",
  class: "pl-m1nde1t5"
});
const renderMobileCtas = ctasToRender => {
  if (!ctasToRender) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "mobile-ctas",
    className: "mobile-ctas"
  }, Array.isArray(ctasToRender) ? /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: ctasToRender?.map(cta => ({
      ...cta,
      shrinkOn: 'mobile'
    }))
  }) : ctasToRender);
};
const renderOfferBanner = (offerBanner, playButtonText, openLightBox) => {
  if (!offerBanner) return null;
  return /*#__PURE__*/_react.default.createElement(BannerWrapper, {
    className: "offer-banner-wrapper",
    "data-partial": "light1"
  }, /*#__PURE__*/_react.default.isValidElement(offerBanner) ? offerBanner : /*#__PURE__*/_react.default.createElement(_offerBanner.default, (0, _extends2.default)({
    playButtonText: playButtonText,
    openLightBox: openLightBox
  }, offerBanner)));
};
const renderHeadlineLockup = (headlineLockup, headlineProps) => {
  if (/*#__PURE__*/_react.default.isValidElement(headlineLockup)) {
    return /*#__PURE__*/_react.default.cloneElement(headlineLockup, {
      ctas: null
    });
  }
  return /*#__PURE__*/_react.default.createElement(_headlineLockup.default, (0, _extends2.default)({}, headlineProps, {
    headlineSize: "h2",
    textAlign: "center",
    actionsLayout: "button-set",
    ctas: null
  }));
};

/**
 * ScrollableSection Component.
 *
 * @param {Object} props React props
 * @param {Object} props.headlineProps HeadlineLockup props
 * @param {string} props.playButtonText PlayButton text
 * @param {Function} props.openLightBox PlayButton click handler
 * @param {Object|Node} props.offerBanner OfferBanner props or React component
 * @param {Object} props.navHeights Navigation heights
 * @param {Object|Node} props.headlineLockup HeadlineLockup component storefront props or React node
 * @returns {React.ReactElement} ScrollableSection Component
 * @public
 */
function ScrollableSection({
  headlineProps,
  headlineLockup,
  playButtonText,
  openLightBox,
  offerBanner,
  navHeights,
  noBannerOnMobile = false
}) {
  const headlineLockupCtas = /*#__PURE__*/_react.default.isValidElement(headlineLockup) && headlineLockup.props?.ctas ? headlineLockup.props.ctas : null;
  const ctasToRender = headlineLockupCtas || headlineProps.ctas;
  return /*#__PURE__*/_react.default.createElement(ScrollableContentContainer, {
    "data-partial": "dark1",
    className: noBannerOnMobile ? 'no-banner-on-mobile' : ''
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(ContentBlock, {
    mode: "fluid",
    intensity: "500",
    variant: "moveUpFixed",
    navHeights: navHeights,
    headlineLineLength: headlineProps.headlineLineLength
  }, renderHeadlineLockup(headlineLockup, headlineProps), renderMobileCtas(ctasToRender)), renderOfferBanner(offerBanner, playButtonText, openLightBox), noBannerOnMobile && /*#__PURE__*/_react.default.createElement(MobilePlayButton, {
    className: "mobile-play-button"
  }, playButtonText && /*#__PURE__*/_react.default.createElement(_offerBanner.Controls, null, /*#__PURE__*/_react.default.createElement(_playButton.default, {
    dataCy: "lightbox-play-button",
    invert: true,
    handlePlay: openLightBox,
    size: "small",
    buttonText: playButtonText
  })))));
}
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(ScrollableSection);
ScrollableSection.propTypes = {
  headlineProps: _propTypes.default.object,
  playButtonText: _propTypes.default.string,
  openLightBox: _propTypes.default.func,
  offerBanner: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  navHeights: _propTypes.default.object,
  headlineLockup: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  noBannerOnMobile: _propTypes.default.bool
};